export default __webpack_public_path__ + "static/media/service.61193de1.svg";